import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
}

const CountryDetailOptionsPanel = (props: Props) => {
  return <>
    <GeneralOptionsPanel data={props.optionsPanelData} links={[{
      text: RESX.Buttons.ListView,
      href: props.listUrl,
      visible: true
    }]} />
  </>;
};

export default CountryDetailOptionsPanel;